import {
  FETCH_ORDER_FULFILLED,
  FETCH_ORDER_PENDING,
  FETCH_ORDER_REJECTED,
} from '../../reducers/tools/decisionTree/fetchOrder';
import { selectOrder } from './OrdersSearchActions';
import { showErrorMessage } from '../../util/errorPopupUtil';
import { processAmazonOrderCancellation } from './DecisionTree/AmazonActions';

export const fetchOrderPending = () => {
  return {
    type: FETCH_ORDER_PENDING,
  };
};

export const fetchOrderFulfilled = () => {
  return {
    type: FETCH_ORDER_FULFILLED,
  };
};

export const fetchOrderRejected = (error) => {
  return {
    type: FETCH_ORDER_REJECTED,
    error,
  };
};

export const fetchAmazonOrder = (order) => async (dispatch) => {
  try {
    dispatch(selectOrder(order));
    dispatch(fetchOrderPending());

    await dispatch(processAmazonOrderCancellation());

    dispatch(fetchOrderFulfilled());
  } catch (e) {
    showErrorMessage();
    dispatch(fetchOrderRejected(e));
  }
};
